import Button from "@mui/material/Button"
import { useTheme } from "@mui/material/styles"
const SecondaryButton = (props) => {
  const theme = useTheme()

  const { sx } = props
  return (
    <Button
      variant="contained"
      color="secondary"
      disableElevation={true}
      {...props}
      sx={{
        mt: 4,
        height: "54px",
        textTransform: "none",
        whiteSpace: "nowrap",
        borderRadius: 10,
        fontWeight: 700,
        fontSize: theme.direction === "rtl" ? "18px" : "16px",
        boxShadow: "0px 6px 20px 0px #F9515A80",
        "&.Mui-disabled": {
          backgroundColor: "#EF959C",
          color: "white",
        },
        ...sx,
      }}
    >
      {props.text}
    </Button>
  )
}

export default SecondaryButton
